"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Trustpilot;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = require("@site/pattern-library-core/image");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _renderRating = require("../../../page-body/sections/smart-testimonials-section/render-rating.js");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _settings = require("@site/pattern-library-core/settings");
const TrustpilotContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrustpilotContainer",
  class: "pl-taxg9h",
  vars: {
    "taxg9h-0": [({
      inset
    }) => inset ? '0.375rem' : '0'],
    "taxg9h-1": [({
      backgroundColor
    }) => backgroundColor ?? 'transparent']
  }
});
const Rating = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Rating",
  class: "pl-r1ekg51n"
});
const RatingTextContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RatingTextContainer",
  class: "pl-r1e00pn0"
});
const Left = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Left",
  class: "pl-ld8idjy"
});
const Right = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Right",
  class: "pl-rwfwncd"
});
const Center = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Center",
  class: "pl-c6n9uln"
});
const Headline = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "Headline",
  class: "pl-hzlt8ed"
});

/**
 * Trustpilot element.
 * @module Trustpilot
 *
 * @param {Object} props React props
 * @param {string} props._name Trustpilot Section Tracking Name
 * @param {string} props.trustpilotUrl Trustpilot Url
 * @param {number} props.rating Number of stars to fill in
 * @param {string} props.ratingText Text next to star rating
 * @param {string} props.eyebrow Eyebrow text left of pipe
 * @param {string} props.headline Headline text left of pipe
 * @param {Object} props.trustpilotLogo Trustpilot logo image URL and alt text
 * @param {string} props.backgroundColor Background color
 * @param {boolean} props.inset Adds horizontal paddings
 * @param {boolean} props.isMini Trigger for Mini version of mobile layout
 * @param {string} props.verticalMargin Vertical Spacing value
 * @returns {React.ReactElement} Trustpilot Element
 * @public
 */

function Trustpilot({
  _name,
  trustpilotUrl,
  trustpilotLogo,
  rating,
  ratingText,
  eyebrow,
  headline,
  backgroundColor = 'transparent',
  inset,
  isMini,
  verticalMargin = 'none',
  ariaLabel
}) {
  const formatRatingText = str => {
    const beforeInd = str.indexOf('[');
    const afterInd = str.indexOf(']');
    const totalReviews = ratingText.substring(beforeInd + 1, afterInd);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ratingText.substring(0, beforeInd), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, totalReviews), ratingText.substring(afterInd + 1));
  };
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: "trustpilot-section",
    "aria-label": ariaLabel,
    padding: inset ? 'large' : 'none',
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(TrustpilotContainer, {
    inset: inset,
    backgroundColor: backgroundColor,
    "data-cy": "trustpilot",
    "aria-label": ariaLabel,
    className: isMini && 'mini-tp-container'
  }, /*#__PURE__*/_react.default.createElement(Left, {
    className: isMini && 'mini-tp-left'
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": "eyebrow"
  }, eyebrow), /*#__PURE__*/_react.default.createElement(Headline, {
    "data-cy": "headline"
  }, headline)), /*#__PURE__*/_react.default.createElement(Center, {
    className: isMini && 'mini-tp-center'
  }, rating && /*#__PURE__*/_react.default.createElement(Rating, {
    "data-cy": "rating"
  }, (0, _renderRating.renderRating)(rating)), /*#__PURE__*/_react.default.createElement(RatingTextContainer, {
    "data-cy": "rating-text"
  }, formatRatingText(ratingText))), /*#__PURE__*/_react.default.createElement(Right, {
    className: isMini && 'mini-tp-right'
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: trustpilotUrl,
    rel: "noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_image.LazyImage, trustpilotLogo)))));
}
Trustpilot.propTypes = {
  _name: _propTypes.default.string,
  trustpilotLogo: _propTypes.default.shape(_image.imgPropShape).isRequired,
  rating: _propTypes.default.oneOf(_settings.TrustPilotRatings),
  ratingText: _propTypes.default.string,
  eyebrow: _propTypes.default.string,
  headline: _propTypes.default.string,
  trustpilotUrl: _propTypes.default.string.isRequired,
  backgroundColor: _propTypes.default.string,
  inset: _propTypes.default.bool,
  isMini: _propTypes.default.bool,
  ariaLabel: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps
};